import React, { useState, useRef, useEffect } from 'react';
import { Bell } from 'lucide-react';
import NotificationDropdown from './NotificationDropdown';
import { NotificationService } from '../services/NotificationService';

const NotificationBell = ({ notifications, userId }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const unreadCount = notifications.filter(n => !n.read).length;
    const unseenCount = notifications.filter(n => !n.seen).length;

    // Close on click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleToggle = () => {
        if (!isOpen && unseenCount > 0) {
            NotificationService.markAllAsSeen(userId);
        }
        setIsOpen(!isOpen);
    };

    const handleMarkAllRead = () => {
        // Optimistically update UI or just wait for Firebase
        notifications.forEach(n => {
            if (!n.read) NotificationService.markAsRead(userId, n.id);
        });
    };

    const handleClearAll = () => {
        NotificationService.clearAll(userId);
    };

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                onClick={handleToggle}
                className="p-2 text-slate-500 hover:bg-slate-100 rounded-full transition-colors relative"
            >
                <Bell size={20} />
                {unreadCount > 0 && (
                    <span className="absolute top-1.5 right-1.5 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white" />
                )}
            </button>

            {isOpen && (
                <NotificationDropdown
                    notifications={notifications}
                    onMarkAllRead={handleMarkAllRead}
                    onClearAll={handleClearAll}
                    onClose={() => setIsOpen(false)}
                />
            )}
        </div>
    );
};

export default NotificationBell;
